<div
	[ngClass]="{
		remove_horizontal_padding: removeContainerHorizontalPadding || removeTableContainerPadding,
	}"
>
	<nav
		mat-tab-nav-bar
		[tabPanel]="tabPanel"
		[ngClass]="{ border_bottom_hidden: !showTabBars }"
		class="hide_mat_ink_bar"
		[disablePagination]="disableTabNavPagination"
	>
		<!-- Dropdown Tab Layout (New) - Separate row for proper alignment -->
		<div *ngIf="!isSmallScreen && useDropdownTabs && showTabBars" class="dropdown-tab-row">
			<button class="action-button" color="primary" mat-raised-button [matMenuTriggerFor]="tabMenu">
				{{ activeLink }} <mat-icon>keyboard_arrow_down</mat-icon>
			</button>
		</div>

		<div
			class="full-width"
			[fxLayout]="isSmallScreen ? 'column' : 'row'"
			[fxLayoutAlign]="
				isSmallScreen ? 'center stretch' : useDropdownTabs ? 'end center' : 'space-between center'
			"
		>
			<!-- Original Horizontal Tab Layout (Existing) -->
			<div
				fxLayout="row"
				[ngClass]="{ 'tab-header-container': tabScrollEnabled }"
				*ngIf="!isSmallScreen && !useDropdownTabs"
			>
				<button
					mat-stroked-button
					class="tabbed-table__scroll-btn tabbed-table__scroll-btn__left p-0"
					(click)="scrollTabs('left')"
					[disabled]="isAtStart"
					*ngIf="tabScrollEnabled"
				>
					<mat-icon>chevron_left</mat-icon>
				</button>

				<div
					*ngIf="showTabBars"
					class="cc_tab_headers_container"
					[ngStyle]="{ 'max-width': tabHeadersMaxWidth ? tabHeadersMaxWidth + 'px' : '' }"
					#tabHeaderScroll
					id="cc_tab_headers_container"
				>
					<a
						mat-tab-link
						*ngFor="let link of links; let i = index"
						#tabLinks
						(click)="changeActiveLink(link, i)"
						[active]="selectedTabIndex === i"
						class="cc_tab_headers"
					>
						{{ link }}
					</a>
				</div>

				<button
					mat-stroked-button
					class="tabbed-table__scroll-btn tabbed-table__scroll-btn__right p-0"
					(click)="scrollTabs('right')"
					[disabled]="isAtEnd"
					*ngIf="tabScrollEnabled"
				>
					<mat-icon>chevron_right</mat-icon>
				</button>
			</div>
			<div
				class="full-width"
				*ngIf="
					showActionButton && isActionbuttonDisabled && promptActionsText?.length && !isSmallScreen
				"
			>
				{{ promptActionsText }}
			</div>
			<div
				class="full-width"
				*ngIf="
					showActionButton &&
					!isActionbuttonDisabled &&
					actionTextDescriptions?.length &&
					!isSmallScreen
				"
			>
				<ng-container
					*ngFor="
						let actionTextDescription of actionTextDescriptions;
						let i = index;
						trackBy: trackByIndex
					"
				>
					<span class="p-l-1" fxLayout="row" fxLayoutAlign="start center">
						{{ actionTextDescription }}
					</span>
				</ng-container>
			</div>
			<div
				[fxLayout]="isSmallScreen ? 'column' : 'row'"
				[fxLayoutAlign]="isSmallScreen ? 'center stretch' : 'end center'"
				fxLayoutGap="0.5rem"
				id="cc_tab_headers_actions"
				[ngClass]="{ 'full-width': isFullWidthActionRow }"
			>
				<div
					fxLayout="row"
					[fxLayoutAlign]="isSmallScreen ? 'space-between center' : 'start center'"
					[fxLayoutGap]="isSmallScreen ? '0.5rem' : '0'"
				>
					<button
						*ngIf="showAddProjectsButton && productsService.PROJECT_CARRIERS"
						(click)="newProjectClicked()"
						color="primary"
						mat-raised-button
					>
						{{ addProjectsButtonText }}
					</button>

					<button
						*ngIf="
							showPostLoadButton &&
							(utilService.isAccountTypeBroker() || utilService.isAccountTypeShipper()) &&
							accountSettings.POST_LOAD
						"
						(click)="postLoadOnClick()"
						color="primary"
						mat-raised-button
					>
						<mat-icon class="m-r-1">event_note</mat-icon>
						<span>Post a Load</span>
					</button>

					<button
						*ngIf="showUpdateViewButton && !(activeLink === links[0])"
						class="action-button"
						color="primary"
						[matMenuTriggerFor]="saveView"
						mat-raised-button
					>
						Update View <mat-icon>keyboard_arrow_down</mat-icon>
					</button>

					<button
						*ngIf="showSaveViewButton && activeLink === links[0]"
						class="action-button"
						color="primary"
						[disabled]="!(sortState?.length || filterState?.length)"
						[matMenuTriggerFor]="saveView"
						mat-raised-button
					>
						Save View as: {{ filterState }}<mat-icon>keyboard_arrow_down</mat-icon>
					</button>
					<button
						*ngIf="showLoadTypeDropdown"
						[class]="isSmallScreen ? 'action-button-small-screen' : 'action-button'"
						[fxFlex]="isSmallScreen ? '33' : 'none'"
						color="primary"
						mat-raised-button
						[matMenuTriggerFor]="loadTypeMenu"
					>
						{{ selectedLoadType }} <mat-icon>keyboard_arrow_down</mat-icon>
					</button>

					<button
						*ngIf="showFilterButton"
						[disabled]="!enableFilterButton"
						[class]="isSmallScreen ? 'action-button-small-screen' : 'action-button'"
						[fxFlex]="isSmallScreen ? '33' : 'none'"
						color="primary"
						mat-raised-button
						[mtxPopoverTriggerFor]="filterPopover"
						mtxPopoverTriggerOn="click"
					>
						Filter <span>{{ filterState }}</span>
						<mat-icon>keyboard_arrow_down</mat-icon>
					</button>
					<button
						*ngIf="showSortButton"
						[disabled]="!enableSortButton"
						[class]="isSmallScreen ? 'action-button-small-screen' : 'action-button'"
						[fxFlex]="isSmallScreen ? '33' : 'none'"
						color="primary"
						mat-raised-button
						[mtxPopoverTriggerFor]="sortPopover"
						mtxPopoverTriggerOn="click"
					>
						Sort <span>{{ sortState }}</span>
						<mat-icon>keyboard_arrow_down</mat-icon>
					</button>
					<!-- CN-8862: the Run (import) button sits with the other top toolbar buttons.
					     Only the Bulk Rating / RFP screen sets showImportRFPButton. -->
					<button
						*ngIf="showImportRFPButton"
						[class]="isSmallScreen ? 'action-button-small-screen' : 'action-button'"
						[fxFlex]="isSmallScreen ? '33' : 'none'"
						color="primary"
						mat-raised-button
						(click)="importRFPs({})"
					>
						{{ importRFPButtonLabel }}
					</button>
				</div>

				<!-- Action button - second row on small screens, same row on large screens -->
				<div fxLayout="row" *ngIf="!isSmallScreen">
					<button
						*ngIf="showActionButton && actions.length > 1"
						color="primary"
						[disabled]="isActionbuttonDisabled && disableActions"
						[matMenuTriggerFor]="menu"
						mat-raised-button
						(click)="$event.stopPropagation()"
					>
						Actions <mat-icon>keyboard_arrow_down</mat-icon>
					</button>
					<button
						*ngIf="showActionButton && actions.length == 1"
						color="primary"
						(click)="firstAction().action(selection.selected)"
						[disabled]="isActionbuttonDisabled && disableActions"
						mat-raised-button
					>
						{{
							firstAction().dynamicLabel
								? firstAction().dynamicLabel(selection.selected)
								: firstAction().label
						}}
					</button>
				</div>

				<!-- Action buttons on small screens - separate row -->
				<div fxLayout="column" fxLayoutGap="0.5rem" *ngIf="isSmallScreen">
					<button
						*ngIf="showAddProjectsButton && productsService.PROJECT_CARRIERS"
						(click)="newProjectClicked()"
						[class]="isSmallScreen ? 'action-button-small-screen' : 'action-button'"
						color="primary"
						mat-raised-button
					>
						{{ addProjectsButtonText }}
					</button>

					<button
						*ngIf="
							showPostLoadButton &&
							(utilService.isAccountTypeBroker() || utilService.isAccountTypeShipper()) &&
							accountSettings.POST_LOAD
						"
						(click)="postLoadOnClick()"
						color="primary"
						mat-raised-button
					>
						<mat-icon class="m-r-1">event_note</mat-icon>
						<span>Post a Load</span>
					</button>

					<button
						*ngIf="showUpdateViewButton && !(activeLink === links[0])"
						class="action-button-small-screen"
						color="primary"
						[matMenuTriggerFor]="saveView"
						mat-raised-button
					>
						Update View <mat-icon>keyboard_arrow_down</mat-icon>
					</button>
					<button
						*ngIf="showSaveViewButton && activeLink === links[0]"
						class="action-button-small-screen"
						color="primary"
						[disabled]="!(sortState?.length || filterState?.length)"
						[matMenuTriggerFor]="saveView"
						mat-raised-button
					>
						Save View as: {{ filterState }}<mat-icon>keyboard_arrow_down</mat-icon>
					</button>

					<button
						*ngIf="showActionButton && actions.length > 1"
						class="action-button-small-screen"
						color="primary"
						[disabled]="isActionbuttonDisabled && disableActions"
						[matMenuTriggerFor]="menu"
						mat-raised-button
						(click)="$event.stopPropagation()"
					>
						Actions <mat-icon>keyboard_arrow_down</mat-icon>
					</button>
					<button
						*ngIf="showActionButton && actions.length == 1"
						class="action-button-small-screen"
						color="primary"
						(click)="firstAction().action(selection.selected)"
						[disabled]="isActionbuttonDisabled && disableActions"
						mat-raised-button
					>
						{{
							firstAction().dynamicLabel
								? firstAction().dynamicLabel(selection.selected)
								: firstAction().label
						}}
					</button>
				</div>
			</div>
		</div>
	</nav>
	<mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>

	<mat-menu #menu="matMenu" xPosition="before">
		<button
			mat-menu-item
			*ngFor="let actionElement of actions"
			(click)="actionElement.action(selection.selected)"
			[disabled]="actionElement.disabled(selection.selected)"
		>
			<span>
				{{
					actionElement.dynamicLabel
						? actionElement.dynamicLabel(selection.selected)
						: actionElement.label
				}}
			</span>
		</button>
	</mat-menu>

	<mtx-popover
		#filterPopover="mtxPopover"
		[closeOnPanelClick]="false"
		[position]="['below', 'before']"
	>
		<mat-card class="p-0 popover_default_width">
			<mat-card-content>
				<form [formGroup]="filterForm" (keydown.enter)="$event.preventDefault()">
					<div class="p-1 label-text" fxLayout="column">
						<div fxLayout="row" fxLayoutGap="1rem">
							<div fxFlex fxLayoutAlign="end center">
								<span fxFlex fxLayoutAlign="start center"> In this view, show records </span>
							</div>
						</div>
						<div
							class="p-r-1"
							fxFlex
							fxLayoutAlign="center center"
							formArrayName="formArray"
							*ngFor="let field of formArray.controls; let i = index"
						>
							<div [formGroupName]="i" fxFlex fxLayoutAlign="center center">
								<div *ngIf="i === 0" class="p-1" fxFlex fxLayoutAlign="center center">
									<span class="condition-field">Where</span>
								</div>
								<div *ngIf="i >= 1" class="p-1" fxFlex fxLayoutAlign="center center">
									<mat-form-field class="condition-field">
										<mat-label>Condition</mat-label>
										<mat-select formControlName="filterCondition">
											<mat-option [value]="AND">and</mat-option>
											<mat-option [value]="OR">or</mat-option>
										</mat-select>
									</mat-form-field>
								</div>
								<mat-form-field [ngClass]="{ disabled_form_field: field?.value?.isNotDeletable }">
									<mat-label>Filter Field</mat-label>
									<input
										#filterTrigger="matAutocompleteTrigger"
										type="text"
										placeholder="Filter Field"
										aria-label="Filter Field"
										matInput
										[matAutocomplete]="autoFilter"
										[formControl]="formArray.at(i).get('filterField')"
										(input)="setFilterTextForInvalidFilterField(formArray.at(i), filterTrigger)"
									/>
									<mat-autocomplete
										autoActiveFirstOption
										#autoFilter="matAutocomplete"
										(optionSelected)="onFilterFieldSelection(i)"
									>
										<mat-option
											class="font-size-12"
											*ngFor="let option of filterOptions[i] | async"
											[value]="option"
										>
											{{ option }}
										</mat-option>
									</mat-autocomplete>
								</mat-form-field>
								<div class="p-1" fxFlex fxLayoutAlign="center center">
									<span *ngIf="!filterFieldsInputTypeMap?.get(field.value?.filterField || '')">
										Contains
									</span>
									<span
										*ngIf="
											filterFieldsInputTypeMap?.get(field.value.filterField || '') === 'usersList'
										"
									>
										In
									</span>
									<span *ngIf="filterFieldsInputTypeMap?.get(field.value.filterField) === 'date'">
										Range
									</span>

									<span
										*ngIf="
											['customer', 'carrier', 'carrierAccounts'].includes(
												filterFieldsInputTypeMap?.get(field.value.filterField)
											)
										"
									>
										Equals
									</span>

									<mat-form-field
										*ngIf="
											filterFieldsInputTypeMap?.get(field.value.filterField) === 'location' ||
											filterFieldsInputTypeMap?.get(field.value.filterField) === 'statesList'
										"
									>
										<mat-label>Operator</mat-label>
										<mat-select formControlName="operator">
											<mat-option
												*ngFor="let operator of OPERATOR_OPTIONS.LOCATION"
												[value]="operator"
											>
												{{ LOCATION_OPERATORS_LABEL[operator] }}
											</mat-option>
										</mat-select>
									</mat-form-field>

									<mat-form-field
										*ngIf="filterFieldsInputTypeMap?.get(field.value.filterField) === 'project'"
									>
										<mat-label>Operator</mat-label>
										<mat-select
											formControlName="operator"
											(selectionChange)="onProjectOperatorChange($event, field)"
										>
											<mat-option
												*ngFor="let operator of OPERATOR_OPTIONS.PROJECT"
												[value]="operator"
											>
												{{ PROJECT_OPERATORS_LABEL[operator] }}
											</mat-option>
										</mat-select>
									</mat-form-field>

									<mat-form-field
										*ngIf="filterFieldsInputTypeMap?.get(field.value.filterField) === 'number'"
									>
										<mat-label>Operator</mat-label>
										<mat-select formControlName="operator">
											<mat-option
												*ngFor="let operator of OPERATOR_OPTIONS.NUMBER"
												[value]="operator"
											>
												{{ operator }}
											</mat-option>
										</mat-select>
									</mat-form-field>

									<mat-form-field
										*ngIf="
											filterFieldsInputTypeMap?.get(field.value.filterField) === 'allocatedCarriers'
										"
									>
										<mat-label>Operator</mat-label>
										<mat-select formControlName="operator">
											<mat-option
												*ngFor="let operator of OPERATOR_OPTIONS.ALLOCATED_CARRIERS"
												[value]="operator"
											>
												{{ operator }}
											</mat-option>
										</mat-select>
									</mat-form-field>

									<mat-form-field
										*ngIf="filterFieldsInputTypeMap?.get(field.value.filterField) === 'volume'"
									>
										<mat-label>Operator</mat-label>
										<mat-select formControlName="operator">
											<mat-option
												*ngFor="let operator of OPERATOR_OPTIONS.VOLUME"
												[value]="operator"
											>
												{{ operator }}
											</mat-option>
										</mat-select>
									</mat-form-field>

									<mat-form-field
										*ngIf="filterFieldsInputTypeMap?.get(field.value.filterField) === 'string'"
									>
										<mat-label>Operator</mat-label>
										<mat-select formControlName="operator">
											<mat-option
												*ngFor="let operator of OPERATOR_OPTIONS.STRING"
												[value]="operator"
											>
												{{ operator }}
											</mat-option>
										</mat-select>
									</mat-form-field>

									<mat-form-field
										*ngIf="filterFieldsInputTypeMap?.get(field.value.filterField) === 'stage'"
									>
										<mat-label>Operator</mat-label>
										<mat-select formControlName="operator">
											<mat-option
												*ngFor="let operator of OPERATOR_OPTIONS.STAGE"
												[value]="operator"
											>
												{{ STAGE_OPERATORS_LABEL[operator] }}
											</mat-option>
										</mat-select>
									</mat-form-field>

									<mat-form-field
										*ngIf="filterFieldsInputTypeMap?.get(field.value.filterField) === 'jobStatus'"
									>
										<mat-label>Operator</mat-label>
										<mat-select formControlName="operator">
											<mat-option
												*ngFor="let operator of OPERATOR_OPTIONS.JOB_STATUS"
												[value]="operator"
											>
												{{ JOB_STATUS_OPERATORS_LABEL[operator] }}
											</mat-option>
										</mat-select>
									</mat-form-field>

									<mat-form-field
										*ngIf="
											filterFieldsInputTypeMap?.get(field.value.filterField) ===
											'importStatsJobStatus'
										"
									>
										<mat-label>Operator</mat-label>
										<mat-select formControlName="operator">
											<mat-option
												*ngFor="let operator of OPERATOR_OPTIONS.JOB_STATUS"
												[value]="operator"
											>
												{{ JOB_STATUS_OPERATORS_LABEL[operator] }}
											</mat-option>
										</mat-select>
									</mat-form-field>

									<mat-form-field
										*ngIf="filterFieldsInputTypeMap?.get(field.value.filterField) === 'userStatus'"
									>
										<mat-label>Operator</mat-label>
										<mat-select formControlName="operator">
											<mat-option
												*ngFor="let operator of OPERATOR_OPTIONS.USER_STATUS"
												[value]="operator"
											>
												{{ EQUAL_NOT_EQUAL_TYPES_LABEL[operator] }}
											</mat-option>
										</mat-select>
									</mat-form-field>

									<mat-form-field
										*ngIf="filterFieldsInputTypeMap?.get(field.value.filterField) === 'userRole'"
									>
										<mat-label>Operator</mat-label>
										<mat-select formControlName="operator">
											<mat-option
												*ngFor="let operator of OPERATOR_OPTIONS.USER_ROLE"
												[value]="operator"
											>
												{{ EQUAL_NOT_EQUAL_TYPES_LABEL[operator] }}
											</mat-option>
										</mat-select>
									</mat-form-field>

									<mat-form-field
										*ngIf="filterFieldsInputTypeMap?.get(field.value.filterField) === 'boolean'"
									>
										<mat-label>Operator</mat-label>
										<mat-select formControlName="operator">
											<mat-option
												*ngFor="let operator of OPERATOR_OPTIONS.ARCHIVED"
												[value]="operator"
											>
												{{ ARCHIVED_OPERATORS_LABEL[operator] }}
											</mat-option>
										</mat-select>
									</mat-form-field>

									<mat-form-field
										*ngIf="filterFieldsInputTypeMap?.get(field.value.filterField) === 'trailerType'"
									>
										<mat-label>Operator</mat-label>
										<mat-select formControlName="operator">
											<mat-option
												*ngFor="let operator of OPERATOR_OPTIONS.TRAILER_TYPE"
												[value]="operator"
											>
												{{ EQUAL_NOT_EQUAL_TYPES_LABEL[operator] }}
											</mat-option>
										</mat-select>
									</mat-form-field>

									<mat-form-field
										*ngIf="filterFieldsInputTypeMap?.get(field.value.filterField) === 'projectType'"
									>
										<mat-label>Operator</mat-label>
										<mat-select formControlName="operator">
											<mat-option
												*ngFor="let operator of OPERATOR_OPTIONS.PROJECT_TYPE"
												[value]="operator"
											>
												{{ EQUAL_NOT_EQUAL_TYPES_LABEL[operator] }}
											</mat-option>
										</mat-select>
									</mat-form-field>

									<mat-form-field
										*ngIf="filterFieldsInputTypeMap?.get(field.value.filterField) === 'company'"
									>
										<mat-label>Operator</mat-label>
										<mat-select formControlName="operator">
											<mat-option
												*ngFor="let operator of OPERATOR_OPTIONS.COMPANY"
												[value]="operator"
											>
												{{ EQUAL_NOT_EQUAL_TYPES_LABEL[operator] }}
											</mat-option>
										</mat-select>
									</mat-form-field>
								</div>

								<mat-form-field
									*ngIf="
										!filterFieldsInputTypeMap?.get(field?.value?.filterField || '') ||
										filterFieldsInputTypeMap?.get(field?.value?.filterField || '') === 'string'
									"
								>
									<input
										formControlName="filterText"
										matInput
										name="filter-text"
										placeholder="Filter Text"
										type="text"
									/>
								</mat-form-field>
								<ng-container *ngIf="field?.value?.filterField">
									<mat-form-field
										*ngIf="filterFieldsInputTypeMap?.get(field.value.filterField) === 'location'"
									>
										<input
											#LocationCtrl="ngModel"
											(setAddress)="setLocationValue($event, field)"
											[(ngModel)]="locationModel[field.value.filterField + i]"
											[ngModelOptions]="{ standalone: true }"
											[allowStateSelection]="true"
											appGoogleLocation
											matInput
											[placeholder]="field.value.filterField"
											type="text"
										/>
									</mat-form-field>
									<mat-form-field
										*ngIf="filterFieldsInputTypeMap?.get(field.value.filterField) === 'trailerType'"
									>
										<mat-label>Equipments</mat-label>
										<mat-select
											panelClass="customer-select-panel-class"
											disableOptionCentering
											formControlName="filterText"
											multiple
											#trailerType
											(keypress)="trailerTypeKeyPress($event.key, field.value.filterText, i)"
											[compareWith]="compareEquipment"
										>
											<div class="mat_select_options_max_height">
												<mat-option *ngFor="let trailer of trailerTypes" [value]="trailer.dbVal">
													{{ trailer.value }}
												</mat-option>
											</div>
											<div fxFlexLayout="row" class="p-0-5">
												<button
													mat-flat-button
													color="primary"
													(click)="trailerType?.close()"
													fxFlex
												>
													Save
												</button>
											</div>
										</mat-select>
									</mat-form-field>

									<mat-form-field
										*ngIf="filterFieldsInputTypeMap?.get(field.value.filterField) === 'projectType'"
									>
										<mat-label>Project Type</mat-label>
										<mat-select
											panelClass="customer-select-panel-class"
											disableOptionCentering
											formControlName="filterText"
											multiple
											#projectTypeSelect
										>
											<div class="mat_select_options_max_height">
												<mat-option
													*ngFor="let projectType of PROJECT_TYPES | keyvalue"
													[value]="projectType.value.value"
												>
													{{ projectType.value.label }}
												</mat-option>
											</div>
											<div fxFlexLayout="row" class="p-0-5">
												<button
													mat-flat-button
													color="primary"
													(click)="projectTypeSelect?.close()"
													fxFlex
												>
													Save
												</button>
											</div>
										</mat-select>
									</mat-form-field>

									<div
										*ngIf="filterFieldsInputTypeMap?.get(field.value.filterField) === 'customer'"
									>
										<app-customer-popover
											(setCustomer)="setCustomer($event, field)"
											[customerSelected]="field?.value?.filterText"
										></app-customer-popover>
									</div>

									<div *ngIf="filterFieldsInputTypeMap?.get(field.value.filterField) === 'carrier'">
										<app-carrier-search-popover
											(setCarrier)="setCarrier($event, field)"
											[carrierSelected]="field?.value?.filterText"
											[showCloseIcon]="false"
											[useAutoComplete]="true"
											[usePopover]="false"
											[inNetwork]="false"
											placeholder=""
										>
										</app-carrier-search-popover>
									</div>

									<div
										*ngIf="
											activeUsersList?.length &&
											filterFieldsInputTypeMap?.get(field.value.filterField) === 'usersList' &&
											activeUsersList.length
										"
									>
										<app-user-selector
											(userChanged)="setAssignedUsersValue($event, field)"
											[multiselect]="true"
											[selectedUsers]="selectedUsers"
											[singleselect]="false"
											[usersList]="activeUsersList"
											customePanelClass="customer-select-panel-class"
											floatLabel="never"
											[placeholder]="usersListPlaceholder"
										></app-user-selector>
									</div>
									<div *ngIf="filterFieldsInputTypeMap?.get(field.value.filterField) === 'date'">
										<app-date-range-selector
											class="date-range"
											placeholder="Date"
											(dateSelected)="dateRangeUpdated($event, field)"
											[previousDateSelector]="showPreviousDates"
											[scorecard]="showScorecardRange"
											[scorecardDateRange]="
												showScorecardRange
													? { startDate: field.value.startValue, endDate: field.value.endValue }
													: null
											"
											[allowAnyDate]="allowAnyDate"
											[customRanges]="dateRangePresets"
											[initialPickupEndDate]="field.value.endValue"
											[initialPickupStartDate]="field.value.startValue"
										>
										</app-date-range-selector>
									</div>

									<div
										*ngIf="filterFieldsInputTypeMap?.get(field.value.filterField) === 'boolean'"
										fxFlex
										fxLayoutAlign="center center"
									>
										<div class="full-width">
											<mat-radio-group
												formControlName="filterText"
												fxFlex
												fxLayout="row"
												fxLayoutGap="1rem"
											>
												<mat-radio-button color="primary" [value]="true">
													{{
														filterFieldsInputLabelMap?.get(field.value.filterField)?.True ?? 'True'
													}}
												</mat-radio-button>
												<mat-radio-button color="primary" [value]="false">
													{{
														filterFieldsInputLabelMap?.get(field.value.filterField)?.False ??
															'False'
													}}
												</mat-radio-button>
											</mat-radio-group>
										</div>
									</div>

									<ng-container
										*ngIf="filterFieldsInputTypeMap?.get(field.value.filterField) === 'number'"
									>
										<mat-form-field *ngIf="field.value.operator !== OPERATORS.BETWEEN">
											<input
												matInput
												formControlName="filterText"
												autocomplete="off"
												mask="separator"
												thousandSeparator=","
											/>
										</mat-form-field>
										<div fxLayoutGap="1rem" *ngIf="field.value.operator === OPERATORS.BETWEEN">
											<mat-form-field>
												<input
													matInput
													formControlName="startValue"
													autocomplete="off"
													mask="separator"
													thousandSeparator=","
													placeholder="From"
												/>
											</mat-form-field>
											<mat-form-field>
												<input
													matInput
													formControlName="endValue"
													autocomplete="off"
													mask="separator"
													thousandSeparator=","
													placeholder="To"
												/>
											</mat-form-field>
										</div>
									</ng-container>

									<ng-container
										*ngIf="
											filterFieldsInputTypeMap?.get(field.value.filterField) === 'allocatedCarriers'
										"
									>
										<mat-form-field *ngIf="field.value.operator !== OPERATORS.BETWEEN">
											<input
												matInput
												formControlName="filterText"
												autocomplete="off"
												mask="separator"
												thousandSeparator=","
											/>
										</mat-form-field>
										<div fxLayoutGap="1rem" *ngIf="field.value.operator === OPERATORS.BETWEEN">
											<mat-form-field>
												<input
													matInput
													formControlName="startValue"
													autocomplete="off"
													mask="separator"
													thousandSeparator=","
													placeholder="From"
												/>
											</mat-form-field>
											<mat-form-field>
												<input
													matInput
													formControlName="endValue"
													autocomplete="off"
													mask="separator"
													thousandSeparator=","
													placeholder="To"
												/>
											</mat-form-field>
										</div>
									</ng-container>

									<ng-container
										*ngIf="filterFieldsInputTypeMap?.get(field.value.filterField) === 'volume'"
									>
										<div fxLayoutGap="1rem">
											<mat-form-field>
												<mat-label> Load Count </mat-label>
												<input
													matInput
													formControlName="startValue"
													autocomplete="off"
													mask="separator"
													thousandSeparator=","
												/>
											</mat-form-field>
											<mat-form-field *ngIf="field.value.operator === OPERATORS.BETWEEN">
												<mat-label> Load Count </mat-label>
												<input
													matInput
													formControlName="endValue"
													autocomplete="off"
													mask="separator"
													thousandSeparator=","
												/>
											</mat-form-field>
											<mat-form-field fxFlex="100">
												<mat-select formControlName="filterText">
													<mat-option
														*ngFor="let duration of LOAD_VOLUME_DURATION"
														[value]="duration"
													>
														{{ duration }}
													</mat-option>
												</mat-select>
											</mat-form-field>
										</div>
									</ng-container>

									<ng-container
										*ngIf="filterFieldsInputTypeMap?.get(field.value.filterField) === 'statesList'"
									>
										<mat-form-field>
											<mat-select
												formControlName="filterText"
												placeholder="Select States"
												multiple
												panelClass="customer-select-panel-class"
												disableOptionCentering
												#statesSelect
											>
												<div class="mat_select_options_max_height">
													<mat-option *ngFor="let state of stateOptions" [value]="state.value">
														{{ state.label }}
													</mat-option>
												</div>
												<div fxFlexLayout="row" class="p-0-5">
													<button
														mat-flat-button
														color="primary"
														(click)="statesSelect?.close()"
														fxFlex
													>
														Save
													</button>
												</div>
											</mat-select>
										</mat-form-field>
									</ng-container>

									<ng-container
										*ngIf="filterFieldsInputTypeMap?.get(field.value.filterField) === 'stage'"
									>
										<mat-form-field>
											<mat-label>Stage</mat-label>
											<mat-select
												formControlName="filterText"
												multiple
												panelClass="customer-select-panel-class"
												disableOptionCentering
												#stageSelect
											>
												<div class="mat_select_options_max_height">
													<mat-option *ngFor="let stage of PROJECT_STAGES" [value]="stage.type">
														{{ stage.label }}
													</mat-option>
												</div>
												<div fxFlexLayout="row" class="p-0-5">
													<button
														mat-flat-button
														color="primary"
														(click)="stageSelect?.close()"
														fxFlex
													>
														Save
													</button>
												</div>
											</mat-select>
										</mat-form-field>
									</ng-container>

									<ng-container
										*ngIf="filterFieldsInputTypeMap?.get(field.value.filterField) === 'userStatus'"
									>
										<mat-form-field>
											<mat-label>Status</mat-label>
											<mat-select
												formControlName="filterText"
												multiple
												panelClass="customer-select-panel-class"
												disableOptionCentering
												#userStatusSelect
											>
												<div class="mat_select_options_max_height">
													<mat-option *ngFor="let status of USER_STATUS" [value]="status.type">
														{{ status.label }}
													</mat-option>
												</div>
												<div fxFlexLayout="row" class="p-0-5">
													<button
														mat-flat-button
														color="primary"
														(click)="userStatusSelect?.close()"
														fxFlex
													>
														Save
													</button>
												</div>
											</mat-select>
										</mat-form-field>
									</ng-container>

									<ng-container
										*ngIf="filterFieldsInputTypeMap?.get(field.value.filterField) === 'userRole'"
									>
										<mat-form-field>
											<mat-label>Role</mat-label>
											<mat-select
												formControlName="filterText"
												multiple
												panelClass="customer-select-panel-class"
												disableOptionCentering
												#userRoleSelect
											>
												<div class="mat_select_options_max_height">
													<mat-option *ngFor="let role of USER_ROLE" [value]="role.type">
														{{ role.label }}
													</mat-option>
												</div>
												<div fxFlexLayout="row" class="p-0-5">
													<button
														mat-flat-button
														color="primary"
														(click)="userRoleSelect?.close()"
														fxFlex
													>
														Save
													</button>
												</div>
											</mat-select>
										</mat-form-field>
									</ng-container>

									<ng-container
										*ngIf="filterFieldsInputTypeMap?.get(field.value.filterField) === 'jobStatus'"
									>
										<mat-form-field>
											<mat-label>Job Status</mat-label>
											<mat-select
												formControlName="filterText"
												multiple
												panelClass="customer-select-panel-class"
												disableOptionCentering
												#jobStatusSelect
											>
												<div class="mat_select_options_max_height">
													<mat-option
														*ngFor="let stage of BULK_CAPACITY_MATCH_JOBS_STATUS"
														[value]="stage.type"
													>
														{{ stage.label }}
													</mat-option>
												</div>
												<div fxFlexLayout="row" class="p-0-5">
													<button
														mat-flat-button
														color="primary"
														(click)="jobStatusSelect?.close()"
														fxFlex
													>
														Save
													</button>
												</div>
											</mat-select>
										</mat-form-field>
									</ng-container>

									<ng-container
										*ngIf="
											filterFieldsInputTypeMap?.get(field.value.filterField) ===
											'importStatsJobStatus'
										"
									>
										<mat-form-field>
											<mat-label>Job Status</mat-label>
											<mat-select
												formControlName="filterText"
												multiple
												panelClass="customer-select-panel-class"
												disableOptionCentering
												#importStatsJobStatus
											>
												<div class="mat_select_options_max_height">
													<mat-option
														*ngFor="let stage of IMPORT_STATS_JOBS_STATUS"
														[value]="stage.type"
													>
														{{ stage.label }}
													</mat-option>
												</div>
												<div fxFlexLayout="row" class="p-0-5">
													<button
														mat-flat-button
														color="primary"
														(click)="importStatsJobStatus?.close()"
														fxFlex
													>
														Save
													</button>
												</div>
											</mat-select>
										</mat-form-field>
									</ng-container>

									<div *ngIf="filterFieldsInputTypeMap?.get(field.value.filterField) === 'project'">
										<div (click)="$event.stopPropagation()" fxFlex fxLayoutAlign="center center">
											<app-project-popover
												(projectSelectedEvent)="setProject($event, field)"
												[isMultiSelectFilter]="true"
												[selectedProjectIds]="field?.value?.filterText"
												[customFormFieldClass]="
													field?.value?.operator === OPERATORS.NOT_EXIST
														? 'disabled_form_field'
														: ''
												"
												fxFlexFill
											>
											</app-project-popover>
										</div>
									</div>

									<ng-container
										*ngIf="filterFieldsInputTypeMap?.get(field.value.filterField) === 'company'"
									>
										<mat-form-field>
											<mat-label>Company</mat-label>
											<mat-select
												formControlName="filterText"
												multiple
												panelClass="customer-select-panel-class"
												disableOptionCentering
												#companyListElement
											>
												<div class="mat_select_options_max_height">
													<mat-option *ngFor="let company of companyList" [value]="company.value">
														{{ company.label }}
													</mat-option>
													<mat-option *ngIf="companyList?.length === 0" disabled>
														No Options
													</mat-option>
												</div>
												<div fxFlexLayout="row" class="p-0-5">
													<button
														mat-flat-button
														color="primary"
														(click)="companyListElement?.close()"
														fxFlex
													>
														Save
													</button>
												</div>
											</mat-select>
										</mat-form-field>
									</ng-container>

									<div
										*ngIf="
											filterFieldsInputTypeMap?.get(field.value.filterField) === 'carrierAccounts'
										"
									>
										<app-network-accounts-popover
											[carrierId]="carrierIdForNetworkAccountsFilter"
											[accountSelected]="field?.value?.filterText"
											(setAccount)="setAccount($event, field)"
										>
										</app-network-accounts-popover>
									</div>
								</ng-container>

								<mat-icon
									(click)="removeFilter(i)"
									class="cursor-pointer"
									*ngIf="formArray.length > 1 && !field?.value?.isNotDeletable"
									fxFlex
									fxLayoutAlign="end center"
								>
									delete_forever
								</mat-icon>
							</div>
						</div>
						<div fxLayout="row" fxLayoutGap="1rem">
							<div fxFlex fxLayoutAlign="end center">
								<span
									fxFlex
									fxLayoutAlign="start center"
									class="primary-text label-text-light font-size-16"
								>
									<span
										fxLayout="row"
										(click)="addFilter()"
										class="cursor-pointer"
										*ngIf="isAddConditionActive"
									>
										<mat-icon class="font-size-16">add</mat-icon>
										<span>Add condition</span>
									</span>
									<span fxLayout="row" class="label-text-light" *ngIf="!isAddConditionActive">
										<mat-icon class="font-size-16">add</mat-icon>
										<span>Add condition</span>
									</span>
								</span>
								<span
									fxFlex
									fxLayoutAlign="end center"
									(click)="clearFilters()"
									class="text-underline cursor-pointer m-r-1 font-size-16"
									>Clear filters</span
								>
								<button
									(click)="filterData()"
									color="primary"
									[disabled]="!isFilterButtonActive"
									mat-raised-button
								>
									<span>Filter</span>
								</button>
							</div>
						</div>
					</div>
				</form>
			</mat-card-content>
		</mat-card>
	</mtx-popover>

	<mtx-popover
		#sortPopover="mtxPopover"
		[closeOnPanelClick]="false"
		[position]="['below', 'before']"
	>
		<mat-card class="p-0 popover_default_width">
			<mat-card-content>
				<form [formGroup]="sortForm">
					<div class="p-1 label-text" fxLayout="column">
						<div
							class="p-r-1"
							fxFlex
							fxLayoutAlign="center center"
							formArrayName="sortFormArray"
							*ngFor="let field of sortFormArray.controls; let i = index"
						>
							<div [formGroupName]="i" fxFlex fxLayoutAlign="center center">
								<div *ngIf="i === 0" class="p-1" fxFlex fxLayoutAlign="center center">
									<span class="condition-field">Sort by</span>
								</div>
								<div *ngIf="i > 0" class="p-1" fxFlex fxLayoutAlign="center center">
									<span class="condition-field">then by</span>
								</div>
								<mat-form-field>
									<mat-label>Sort Field</mat-label>
									<input
										type="text"
										placeholder="Sort Field"
										aria-label="Sort Field"
										matInput
										[formControl]="sortFormArray.at(i).get('sortField')"
										[matAutocomplete]="autoSort"
									/>
									<mat-autocomplete autoActiveFirstOption #autoSort="matAutocomplete">
										<mat-option
											class="font-size-12"
											*ngFor="let option of sortOptions[i] | async"
											[value]="option"
										>
											{{ option }}
										</mat-option>
									</mat-autocomplete>
								</mat-form-field>
								<div class="p-1" fxFlex fxLayoutAlign="center center">
									<span>from</span>
								</div>
								<mat-button-toggle-group *ngIf="isNumberField(i)" formControlName="direction">
									<mat-button-toggle [value]="FIRST_TO_LAST">0-9</mat-button-toggle>
									<mat-button-toggle [value]="LAST_TO_FIRST">9-0</mat-button-toggle>
								</mat-button-toggle-group>
								<mat-button-toggle-group *ngIf="!isNumberField(i)" formControlName="direction">
									<mat-button-toggle [value]="FIRST_TO_LAST">First-Last</mat-button-toggle>
									<mat-button-toggle [value]="LAST_TO_FIRST">Last-First</mat-button-toggle>
								</mat-button-toggle-group>
								<mat-icon
									*ngIf="sortFormArray.length > 1"
									(click)="removeSort(i)"
									class="cursor-pointer"
									fxFlex
									fxLayoutAlign="center center"
								>
									delete_forever
								</mat-icon>
							</div>
						</div>
						<div fxLayout="row" fxLayoutGap="1rem">
							<div fxFlex fxLayoutAlign="end center">
								<span
									fxFlex
									fxLayoutAlign="start center"
									class="primary-text label-text-light font-size-16"
								>
									<span
										fxLayout="row"
										(click)="addSort()"
										class="cursor-pointer"
										*ngIf="isAddFieldActive"
									>
										<mat-icon class="font-size-16">add</mat-icon>
										<span>Add field</span>
									</span>
									<span fxLayout="row" class="label-text-light" *ngIf="!isAddFieldActive">
										<mat-icon class="font-size-16">add</mat-icon>
										<span>Add field</span>
									</span>
								</span>
								<span
									fxFlex
									fxLayoutAlign="end center"
									(click)="clearSort()"
									class="text-underline cursor-pointer m-r-1 font-size-16"
									>Clear fields</span
								>
								<button
									(click)="sortData()"
									color="primary"
									[disabled]="!isSortButtonActive"
									mat-raised-button
								>
									<span>Sort</span>
								</button>
							</div>
						</div>
					</div>
				</form>
			</mat-card-content>
		</mat-card>
	</mtx-popover>

	<mat-menu #saveView="matMenu" xPosition="before">
		<button
			mat-menu-item
			*ngFor="let actionElement of saveViewActions"
			(click)="actionElement.action()"
			[disabled]="actionElement.disabled()"
		>
			<span>{{ actionElement.label }}</span>
		</button>
	</mat-menu>

	<mat-menu #loadTypeMenu="matMenu" xPosition="before">
		<button
			mat-menu-item
			*ngFor="let item of LOAD_TYPE_DROPDOWN_ITEMS"
			(click)="loadTypeToggled(item)"
		>
			<span>{{ item.label }}</span>
			<mat-icon
				class="font-size-20"
				[color]="'primary'"
				[matTooltip]="item.tooltipMessage"
				matTooltipClass="custom-tooltip"
			>
				info
			</mat-icon>
		</button>
	</mat-menu>

	<mat-menu #tabMenu="matMenu" xPosition="before">
		<button
			mat-menu-item
			*ngFor="let link of links; let i = index"
			(click)="changeActiveLink(link, i)"
			[class.active-tab-menu-item]="selectedTabIndex === i"
		>
			<span>{{ link }}</span>
		</button>
	</mat-menu>

	<div
		class="background-white mat-elevation-z1 primary-border data-container"
		[ngClass]="{ 'loading-cursor': loadingData, 'm-t-0-5': !showTabBars }"
	>
		<mat-progress-bar *ngIf="showProgressBar" mode="indeterminate"></mat-progress-bar>

		<div class="p-b-1" *ngIf="!loadingData || dataSource?.data?.length || alwaysShowTableHeaders">
			<table [dataSource]="dataSource" class="full-width" mat-table id="mat_data_table">
				<ng-container matColumnDef="select" *ngIf="rowSelectableEnabled">
					<th *matHeaderCellDef mat-header-cell>
						<mat-checkbox
							*ngIf="selectAllEnabled"
							(change)="$event ? masterToggle() : null"
							[checked]="selection.hasValue() && isAllSelected()"
							[color]="'primary'"
							[disabled]="IS_NULL_OR_UNDEFINED(dataSource) || dataSource?.data?.length === 0"
							[indeterminate]="selection.hasValue() && !isAllSelected()"
						>
						</mat-checkbox>
					</th>
					<td *matCellDef="let row" mat-cell>
						<mat-checkbox
							(change)="$event ? selectRow(row) : null"
							(click)="$event.stopPropagation()"
							[checked]="selection.isSelected(row)"
							[color]="'primary'"
							[disabled]="rowCheckboxIsDisabled && rowCheckboxIsDisabled(row)"
						>
						</mat-checkbox>
					</td>
				</ng-container>

				<ng-container
					[matColumnDef]="column.dataName"
					*ngFor="let column of rowSelectableEnabled ? headers.slice(1) : headers; let i = index"
				>
					<th mat-header-cell *matHeaderCellDef>
						<div class="header_cell_content">
							<span class="fs-13 font-weight-bold primary-text">{{ column.formattedName }}</span>
							<mat-icon
								fxLayoutAlign="center center"
								*ngIf="column.matIcon"
								class="primary-light-color font-size-16"
								[matTooltip]="column.matIconTooltip || ''"
								matTooltipClass="cc_mat_tooltip"
							>
								{{ column.matIcon }}
							</mat-icon>
						</div>
					</th>
					<td
						mat-cell
						*matCellDef="let element"
						class="primary-text"
						[ngClass]="{
							'cursor-pointer': column.action,
							'no-row-click': column.dataName === 'actions',
						}"
						[class.actions-column]="column.dataName === 'actions'"
						(click)="
							column.dataName === 'actions'
								? $event.stopPropagation()
								: column.action && column.action(element)
						"
					>
						<!-- Special handling for actions column -->
						<ng-container *ngIf="column.dataName === 'actions' && customActionsComponent">
							<ng-container
								*ngComponentOutlet="
									customActionsComponent;
									injector: createActionsInjector(element)
								"
								data-actions-component="true"
							>
							</ng-container>
						</ng-container>

						<!-- All other columns use original rendering -->
						<ng-container *ngIf="column.dataName !== 'actions'">
							<div [ngSwitch]="renderedDataTypes[i]">
								<span *ngSwitchCase="'string'">{{
									column.dataName === 'customerName'
										? (element[column.dataName] | titleCase)
										: element[column.dataName]
								}}</span>
								<span *ngSwitchCase="'number'">
									{{
										IS_NOT_NULL_OR_UNDEFINED(element[column.dataName])
											? (element[column.dataName] | number: '1.0-0')
											: ''
									}}
								</span>
								<span *ngSwitchCase="'date'">
									{{
										IS_NOT_NULL_OR_UNDEFINED(element[column.dataName])
											? (element[column.dataName] | date: 'MM/dd/yyyy' : 'UTC')
											: ''
									}}
								</span>
								<!-- Currency stored in cents (legacy format) - divides by 100 -->
								<span *ngSwitchCase="'currency'">
									{{
										IS_NOT_NULL_OR_UNDEFINED(element[column.dataName])
											? (element[column.dataName] / 100 | currency: 'USD')
											: ''
									}}
								</span>
								<!-- Currency stored in dollars (modern format) - no division needed -->
								<span *ngSwitchCase="'currencyAsIs'">
									{{
										IS_NOT_NULL_OR_UNDEFINED(element[column.dataName])
											? (element[column.dataName] | currency: 'USD' : 'symbol' : '1.0-0')
											: ''
									}}
								</span>
								<!-- Percentage display -->
								<span *ngSwitchCase="'percent'">
									{{
										IS_NOT_NULL_OR_UNDEFINED(element[column.dataName])
											? (element[column.dataName] | number: '1.1-1') + '%'
											: ''
									}}
								</span>
								<!-- CN-8872 Bulk Rating "interactive report" meters. These read well-known
								     enriched fields off the row (element.rateConfidence / carrierDepth /
								     progress); native <meter> gives the red→yellow→green coloring. -->
								<ng-template #noMeter><span class="report-meter__empty">—</span></ng-template>
								<span *ngSwitchCase="'rateConfidenceMeter'" class="report-meter">
									<!-- Tooltip + tabindex on the (conditional) trigger so keyboard users can
									     reach it; the "—" dash is not a focusable/tooltip target. Meter bands
									     bind to rateConfidenceMeter (shared source of truth). -->
									<span
										*ngIf="element.rateConfidence != null; else noMeter"
										class="report-meter__hit"
										tabindex="0"
										role="img"
										[matTooltip]="element.rateConfidenceTooltip"
										matTooltipClass="custom-tooltip-multiline"
										[attr.aria-label]="element.rateConfidenceTooltip"
									>
										<meter
											class="report-meter__bar"
											[attr.min]="rateConfidenceMeter.min"
											[attr.low]="rateConfidenceMeter.low"
											[attr.high]="rateConfidenceMeter.high"
											[attr.max]="rateConfidenceMeter.max"
											[attr.optimum]="rateConfidenceMeter.optimum"
											[value]="element.rateConfidence"
										></meter>
									</span>
								</span>
								<span *ngSwitchCase="'carrierDepthMeter'" class="report-meter">
									<span
										*ngIf="element.carrierDepth != null; else noMeter"
										class="report-meter__hit"
										tabindex="0"
										role="img"
										[matTooltip]="element.carrierDepthTooltip"
										matTooltipClass="custom-tooltip-multiline"
										[attr.aria-label]="element.carrierDepthTooltip"
									>
										<meter
											class="report-meter__bar"
											[attr.min]="carrierDepthMeter.min"
											[attr.low]="carrierDepthMeter.low"
											[attr.high]="carrierDepthMeter.high"
											[attr.max]="carrierDepthMeter.max"
											[attr.optimum]="carrierDepthMeter.optimum"
											[value]="element.carrierDepth"
										></meter>
									</span>
								</span>
								<span *ngSwitchCase="'laneConfidenceMeter'" class="report-meter">
									<span
										*ngIf="element.laneConfidence != null; else noMeter"
										class="report-meter__hit"
										tabindex="0"
										role="img"
										[matTooltip]="element.laneConfidenceTooltip"
										matTooltipClass="custom-tooltip-multiline"
										[attr.aria-label]="element.laneConfidenceTooltip"
									>
										<meter
											class="report-meter__bar"
											[attr.min]="laneConfidenceMeter.min"
											[attr.low]="laneConfidenceMeter.low"
											[attr.high]="laneConfidenceMeter.high"
											[attr.max]="laneConfidenceMeter.max"
											[attr.optimum]="laneConfidenceMeter.optimum"
											[value]="element.laneConfidence"
										></meter>
									</span>
								</span>
								<span *ngSwitchCase="'progressMeter'" class="report-progress">
									<ng-container *ngIf="element.progress; else noMeter">
										<span
											class="report-progress__bar"
											[matTooltip]="element.progress.tooltip"
											matTooltipClass="custom-tooltip-multiline"
											tabindex="0"
											role="img"
											[attr.aria-label]="element.progress.tooltip"
										>
											<!-- CN-8917: a FAILED job renders a full red bar (the tooltip explains why),
											     so a failed run is never invisible now that the Job Status column is gone. -->
											<span
												*ngIf="element.progress.jobFailed; else progressSegs"
												class="report-progress__seg report-progress__seg--fail"
												[style.width.%]="100"
											></span>
											<ng-template #progressSegs>
												<span
													class="report-progress__seg report-progress__seg--ok"
													[style.width.%]="element.progress.insertedPct"
												></span>
												<span
													class="report-progress__seg report-progress__seg--warn"
													[style.width.%]="element.progress.invalidPct"
												></span>
												<span
													class="report-progress__seg report-progress__seg--rest"
													[style.width.%]="element.progress.remainderPct"
												></span>
											</ng-template>
										</span>
									</ng-container>
								</span>
								<!-- Trend indicator with color and icon -->
								<span *ngSwitchCase="'trendIndicator'"
									class="trend-indicator"
									[ngClass]="{
										'trend-increasing': element[column.dataName] === 'increasing',
										'trend-decreasing': element[column.dataName] === 'decreasing',
										'trend-stable': element[column.dataName] === 'stable',
										'trend-inactive': element[column.dataName] === 'inactive'
									}"
									[matTooltip]="(element[column.dataName] | titlecase) + (element.trend_pct != null ? ' (' + (element.trend_pct > 0 ? '+' : '') + element.trend_pct + '%)' : '')"
									matTooltipClass="custom-tooltip"
								>
									<mat-icon *ngIf="element[column.dataName] === 'increasing'" class="trend-icon">trending_up</mat-icon>
									<mat-icon *ngIf="element[column.dataName] === 'decreasing'" class="trend-icon">trending_down</mat-icon>
									<mat-icon *ngIf="element[column.dataName] === 'stable'" class="trend-icon">trending_flat</mat-icon>
									<mat-icon *ngIf="element[column.dataName] === 'inactive'" class="trend-icon">remove</mat-icon>
								</span>
								<!-- Usage pattern with color coding -->
								<span *ngSwitchCase="'usagePattern'"
									class="usage-pattern"
									[ngClass]="{
										'pattern-consistent': element[column.dataName] === 'consistent',
										'pattern-volatile': element[column.dataName] === 'volatile',
										'pattern-sporadic': element[column.dataName] === 'sporadic',
										'pattern-one_time': element[column.dataName] === 'one_time'
									}"
									[matTooltip]="element.usage_pattern_detail || ''"
									matTooltipClass="custom-tooltip"
								>
									{{ element[column.dataName] ? (element[column.dataName] === 'one_time' ? 'One-time' : (element[column.dataName] | titlecase)) : '' }}
								</span>
								<!-- Carrier importance with color coding -->
								<span *ngSwitchCase="'carrierImportance'"
									class="carrier-importance"
									[ngClass]="{
										'importance-critical': element[column.dataName] === 'critical',
										'importance-high': element[column.dataName] === 'high',
										'importance-medium': element[column.dataName] === 'medium',
										'importance-low': element[column.dataName] === 'low'
									}"
									[matTooltip]="element.outreach_reason || (element[column.dataName] | titlecase)"
									matTooltipClass="custom-tooltip"
								>
									<mat-icon *ngIf="element.outreach_recommended" class="outreach-icon">priority_high</mat-icon>
									{{ element[column.dataName] | titlecase }}
								</span>
								<span *ngSwitchCase="'statusChip'">
									<mat-chip-list class="status-chip-list">
										<mat-chip [ngClass]="element.statusClass">
											{{ element[column.dataName] }}
										</mat-chip>
										<mat-chip
											*ngIf="element.autoNegotiationPaused"
											class="paused-chip"
											matTooltip="Auto-negotiation paused — a rep took over this carrier. Use Actions → Resume Auto-Negotiation to hand it back."
										>
											<mat-icon class="paused-chip-icon">pause_circle_filled</mat-icon>
											Paused
										</mat-chip>
									</mat-chip-list>
								</span>
								<span *ngSwitchCase="'icon'">
									<mat-icon
										[ngClass]="element[column.dataName + 'Class']"
										[matTooltip]="element[column.dataName + 'Tooltip'] || ''"
										matTooltipClass="custom-tooltip"
									>
										{{ element[column.dataName + 'Icon'] }}
									</mat-icon>
								</span>
								<span *ngSwitchCase="'qualityScore'">
									<span [ngClass]="element[column.dataName]">
										{{ element[column.dataName] }}
									</span>
								</span>
								<!-- CN-8940: the inline styles that used to sit on the name and network
								     icon moved into .carrier-name-cell so the contact-controls layout can
								     override them. The rules are unchanged when showContactActions is off. -->
								<span
									*ngSwitchCase="'carrierNameWithNetwork'"
									class="carrier-name-cell"
									[class.carrier-name-cell--with-contact]="showContactActions"
								>
									<!-- CN-8940: a name too long for the cell truncates rather than wrapping;
									     the directive only shows the tooltip when it actually overflows. -->
									<div
										class="carrier-name-cell__name ellipsis"
										[appTruncateTooltip]="element[column.dataName]"
									>
										<span
											*ngIf="enableCarrierModal"
											(click)="showCarrierModal(element, $event)"
											style="cursor: pointer; color: #4682b4"
											class="carrier-name-clickable"
										>
											<b *ngIf="element.customerCarrier">{{ element[column.dataName] }}</b>
											<span *ngIf="!element.customerCarrier">{{ element[column.dataName] }}</span>
										</span>
										<span *ngIf="!enableCarrierModal">
											<b *ngIf="element.customerCarrier">{{ element[column.dataName] }}</b>
											<span *ngIf="!element.customerCarrier">{{ element[column.dataName] }}</span>
										</span>
									</div>
									<img
										*ngIf="element.customerCarrier && element.networkIconPath"
										class="h-18 carrier-name-cell__network-icon"
										[src]="element.networkIconPath"
										[matTooltip]="element.networkIconTooltip"
										matTooltipClass="custom-tooltip"
									/>
									<app-bid-contact-actions
										*ngIf="contactActionsFor(element) as contactActions"
										class="carrier-name-cell__contact"
										[bid]="contactActions.bid"
										[loadId]="contactActions.loadId"
										[quoteLane]="contactActions.quoteLane"
										[compact]="true"
										(bidContacted)="contactBidContacted.emit($event)"
									>
									</app-bid-contact-actions>
									<div *ngIf="enableOnboardCarrier && element.showOnboardCarrierLink">
										<span
											(click)="$event.stopImmediatePropagation(); onOnboardCarrier.emit(element)"
											class="link font-size-12 cursor-pointer"
										>
											Onboard Carrier
										</span>
									</div>
								</span>
								<span *ngSwitchCase="'businessNameWithHaulPayData'">
									{{ element[column.dataName] }}
									<img
										*ngIf="element.haul_pay_approved"
										class="h-18"
										[src]="haulPayLogoUrl"
										[mtxPopoverTriggerFor]="haulPayTooltip"
										mtxPopoverTriggerOn="hover"
										alt="Haul Pay Approved"
										style="
											vertical-align: middle;
											margin-left: 4px;
											height: 18px;
											width: 18px;
											cursor: pointer;
										"
									/>
									<mtx-popover
										#haulPayTooltip="mtxPopover"
										[position]="['above', 'center']"
										[closeOnPanelClick]="false"
									>
										<div class="p-1 custom-tooltip font-size-14">
											<span [innerHTML]="element?.haulPayLogoTooltip || haulPayLogoTooltip"></span>
										</div>
									</mtx-popover>
								</span>
								<span *ngSwitchCase="'dateTime'">
									{{
										IS_NOT_NULL_OR_UNDEFINED(element[column.dataName])
											? (element[column.dataName] | date: 'MM/dd/yyyy HH:mm:ss' : 'UTC')
											: ''
									}}
								</span>
								<!-- Signed hours delta with red/yellow/green color coding (e.g. offer vs booking time).
									Boundaries: <0 = on-time (green), 0..24 = late-minor (orange), >24 = late-major (red).
									0 counts as "0h after booking" — i.e. arrived at the same moment as booking. -->
								<span *ngSwitchCase="'signedHoursDelta'"
									class="signed-hours-delta"
									[ngClass]="{
										'delta-late-major': element[column.dataName] != null && element[column.dataName] > 24,
										'delta-late-minor': element[column.dataName] != null && element[column.dataName] >= 0 && element[column.dataName] <= 24,
										'delta-on-time': element[column.dataName] != null && element[column.dataName] < 0
									}"
									[matTooltip]="element[column.dataName] != null
										? (element[column.dataName] >= 0
											? element[column.dataName] + 'h after booking'
											: (-element[column.dataName]) + 'h before booking')
										: 'Load not booked'"
									matTooltipClass="custom-tooltip"
								>
									{{
										element[column.dataName] != null
											? (element[column.dataName] >= 0 ? '+' : '') + (element[column.dataName] | number: '1.0-2') + 'h'
											: ''
									}}
								</span>
								<mat-checkbox
									*ngSwitchCase="'checkbox'"
									[checked]="!!element[column.dataName]"
									[disabled]="true"
								></mat-checkbox>
								<span *ngSwitchCase="'link'">
									{{ element[column.dataName] }}
								</span>
								<span
									*ngSwitchCase="'userInfo'"
									[mtxPopoverTriggerFor]="userInfoPopover"
									mtxPopoverTriggerOn="hover"
								>
									{{ element.firstName }} {{ element.lastName }}

									<mtx-popover
										#userInfoPopover="mtxPopover"
										[closeOnPanelClick]="false"
										[position]="['below', 'before']"
									>
										<mat-card class="">
											<mat-card-content>
												<div
													fxLayoutAlign="space-between center"
													class="font-size-14"
													*ngIf="element.email"
												>
													Email:
													<a href="mailto:{{ element.email }}" class="m-l-0-5 font-size-14 link">
														{{ element.email }}
													</a>
												</div>

												<div
													fxLayoutAlign="space-between center"
													class="font-size-14 m-t-0-5"
													*ngIf="element.phoneNumber"
												>
													Phone:
													<a href="tel:{{ element.phoneNumber }}">
														{{ element.phoneNumber | mask: '(000) 000-0000' }}
														{{
															IS_NOT_NULL_OR_UNDEFINED(element.phoneNumber.split('ext.')[1])
																? ' ext. ' + element.phoneNumber.split('ext.')[1]
																: ''
														}}
														<br />
													</a>
												</div>
											</mat-card-content>
										</mat-card>
									</mtx-popover>
								</span>
								<!-- quote date time -->
								<div *ngSwitchCase="'quoteDateTime'">
									<div>
										{{ element[column.dataFields.date] }}
									</div>
									<div class="font-size-10 font_family_roboto">
										{{
											element[column.dataFields.openTime]
												| timeRange
													: (!element[column.dataFields.appointmentRequired]
															? element[column.dataFields.closeTime]
															: null)
										}}
									</div>
								</div>
								<!-- carrier lanes broker account map -->
								<ng-container *ngSwitchCase="'brokerAccountMaps'">
									<ng-container *ngIf="element[column.dataName]?.length as count; else noBrokers">
										<span
											class="link"
											[mtxPopoverTriggerFor]="brokerAccountMapsPopover"
											mtxPopoverTriggerOn="hover"
										>
											{{ count }}
										</span>

										<mtx-popover
											#brokerAccountMapsPopover="mtxPopover"
											[closeOnPanelClick]="false"
											[position]="['below', 'before']"
										>
											<mat-card class="primary-border">
												<mat-card-content>
													<div
														fxLayout="row"
														fxLayoutAlign="space-between center"
														class="m-t-0-5 font-size-13"
														*ngFor="let brokerAccountMap of element[column.dataName]"
													>
														<span>{{ brokerAccountMap.businessName }}</span>
														<span>
															<mat-icon
																class="danger-text cursor-pointer m-l-1"
																(click)="
																	deleteCarrierLaneBrokerAccountMap(brokerAccountMap, element);
																	$event.stopPropagation()
																"
															>
																delete_forever
															</mat-icon>
														</span>
													</div>
												</mat-card-content>
											</mat-card>
										</mtx-popover>
									</ng-container>

									<ng-template #noBrokers>0</ng-template>
								</ng-container>
								<!-- onboarding link -->
								<ng-container *ngSwitchCase="'onboardingLink'">
									<ng-container
										*ngIf="
											IS_NOT_EMPTY(element?.broker_vetting_integration_type) &&
											(IS_NULL_OR_UNDEFINED(element?.carrier_requested_onboarding_at) ||
												DIFFERENCE_FROM_NOW(element?.carrier_requested_onboarding_at, 'hours') > 48)
										"
									>
										<span
											class="link"
											(click)="integrationService.handleOnboarding($event, element)"
											>Get Setup</span
										>
									</ng-container>
								</ng-container>
								<!-- phone number -->
								<ng-container *ngSwitchCase="'phoneNumber'">
									<span
										*ngIf="
											IS_NOT_NULL_OR_UNDEFINED(element.phoneNumber) && element.phoneNumber !== ''
										"
									>
										<a href="tel:{{ element.phoneNumber }}">
											{{ element.phoneNumber | mask: '(000) 000-0000' }}
											{{
												IS_NOT_NULL_OR_UNDEFINED(element.phoneNumber.split('ext.')[1])
													? ' ext. ' + element.phoneNumber.split('ext.')[1]
													: ''
											}}
											<br />
										</a>
									</span>
									<span
										*ngIf="IS_NULL_OR_UNDEFINED(element.phoneNumber) || element.phoneNumber === ''"
									>
										N/A
									</span>
								</ng-container>
							</div>
						</ng-container>
					</td>
				</ng-container>

				<tr *matHeaderRowDef="displayedColumns; sticky: true" mat-header-row></tr>
				<tr
					*matRowDef="let row; columns: displayedColumns"
					mat-row
					[ngClass]="getRowClasses(row)"
					(click)="rowOnClickEnabled ? onRowClick($event, row) : null"
					[matTooltip]="shouldShowTooltip(row) ? tooltipContent : null"
					[matTooltipDisabled]="!shouldShowTooltip(row)"
					matTooltipClass="custom-tooltip"
					class="{{ applyRowClass ? applyRowClass(row) : '' }}"
				></tr>
			</table>
		</div>
		<div
			*ngIf="dataSource?.data?.length === 0 && !loadingData"
			class="p-b-2"
			fxLayoutAlign="center center"
		>
			<span *ngIf="IS_NOT_EMPTY(emptyDataMessage)">
				{{ emptyDataMessage }}
				<mat-spinner
					*ngIf="showEmptyDataSpinner"
					class="m-l-1"
					[diameter]="20"
					strokeWidth="2"
					style="display: inline-block; vertical-align: middle"
				></mat-spinner>
			</span>
			<span *ngIf="IS_EMPTY(emptyDataMessage)">
				No matching {{ dataType }} found.<span *ngIf="filterState.length > 0"
					>&nbsp;Please modify your filter.</span
				>
			</span>
		</div>

		<div *ngIf="!!waitingMessage && loadingData" class="p-b-2" fxLayoutAlign="center center">
			<span>
				{{ waitingMessage }}
				<mat-spinner
					class="m-l-1"
					[diameter]="20"
					strokeWidth="2"
					style="display: inline-block; vertical-align: middle"
				></mat-spinner>
			</span>
		</div>
	</div>

	<div
		fxLayout="row"
		[fxLayoutAlign]="
			showFooterText && footerText && !isSmallScreen ? 'space-between center' : 'end center'
		"
	>
		<div *ngIf="showFooterText && footerText && !isSmallScreen">
			{{ footerText }}
		</div>
		<button
			color="primary"
			*ngIf="showImportProjectsButton && productsService.PROJECT_CARRIERS"
			mat-raised-button
			(click)="importProjectsClicked()"
		>
			Import Projects
		</button>
		<button
			color="primary"
			*ngIf="showImportLoadsButton && productsService.PROJECT_CARRIERS"
			mat-raised-button
			(click)="importLoads({})"
		>
			Import Loads
		</button>
		<button
			color="primary"
			*ngIf="showImportTransactionsButton"
			mat-raised-button
			(click)="importTransactions({})"
		>
			Import Transactions
		</button>

		<app-upload-carriers
			*ngIf="showImportCarrierButton"
			[text]="'Import Carriers'"
			[useButton]="true"
			(carriersCSVUploaded)="carriersCSVUploaded.emit($event)"
		></app-upload-carriers>

		<div>
			<mat-paginator
				*ngIf="isStaticData"
				[length]="dataSource?.data?.length"
				[pageSizeOptions]="PAGE_SIZE_OPTIONS"
				showFirstLastButtons
			>
			</mat-paginator>

			<mat-paginator
				*ngIf="!isStaticData"
				(page)="emitPageEvent()"
				[length]="totalNumberOfRecords"
				[pageSizeOptions]="PAGE_SIZE_OPTIONS"
				showFirstLastButtons
			>
			</mat-paginator>
		</div>
	</div>
</div>
